import { render, staticRenderFns } from "./AddReturnReasonModal.vue?vue&type=template&id=5c13f0ac&scoped=true&"
import script from "./AddReturnReasonModal.vue?vue&type=script&lang=js&"
export * from "./AddReturnReasonModal.vue?vue&type=script&lang=js&"
import style0 from "./AddReturnReasonModal.vue?vue&type=style&index=0&id=5c13f0ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13f0ac",
  null
  
)

export default component.exports